import React from 'react'
import { Avatar, Text, tokens, shorthands, makeStyles } from '@fluentui/react-components'
import { HighlightedValue } from '../outputs/HighlightedValue'

type AvatarNameProps = {
   name: string
   /** Already normalized. Absent outside search. */
   highlightQuery?: string
}

const useStyles = makeStyles({
   avatarWrapper: {
      display: 'flex',
      ...shorthands.gap(tokens.spacingHorizontalXS),
      alignItems: 'center',
   },
})
export const AvatarName = ({ name, highlightQuery }: AvatarNameProps) => {
   const classes = useStyles()
   return (
      <span className={classes.avatarWrapper}>
         <Avatar color={'colorful'} size={24} name={name} />
         <Text>
            <HighlightedValue value={name} query={highlightQuery} />
         </Text>
      </span>
   )
}
